module.exports = "../images/byob-package.jpg?v=d7f0a2e";